module.exports = __webpack_public_path__ + "static/media/img-banner-login-large.8691d2d8.png";